module.exports = __webpack_public_path__ + "static/dark-b60632cce7f877b0a06969543d1df549.svg";